import type { SqlJsBind } from '@core/infrastructure/driven/sqljs/sqljsSqlitePrimitives.ts';
import type { ParticipanteResumen } from '../domain/participanteLookupTypes.ts';

type SqlBind = SqlJsBind;

function optionalPositiveIntFk(v: unknown): number {
  if (v == null || v === '') return 0;
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/** Maps a `participantes` row plus optional `comuna_nombre` join alias into {@link ParticipanteResumen}. */
export function mapParticipanteSqlRowToResumen(p: Record<string, SqlBind>): ParticipanteResumen {
  return {
    id: Number(p.id),
    catalogPublicId: String(p.public_id ?? ''),
    documento: String(p.documento ?? ''),
    nombre: String(p.nombre ?? ''),
    telefono: String(p.telefono ?? ''),
    celular: String(p.celular ?? ''),
    comunaId: optionalPositiveIntFk(p.comuna_id),
    comunaNombre: String(p.comuna_nombre ?? ''),
    barrioId: optionalPositiveIntFk(p.barrio_id),
    tipoDocumentoId: Number(p.tipo_documento_id),
    aceptaTerminos: Number(p.acepta_terminos ?? 0) === 1,
  };
}
